/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connection_Add_DescriptionInputs */



/**
* | output |
* | --- |
* | "Use your own key with a provider, or connect a server you run." |
*
* @param {Private_Models_Connection_Add_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_add_description = /** @type {((inputs?: Private_Models_Connection_Add_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_Add_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzen Sie Ihren eigenen Schlüssel bei einem Anbieter oder binden Sie einen eigenen Server an.")
	return /** @type {LocalizedString} */ ("Use your own key with a provider, or connect a server you run.")
});